/* tslint:disable */
/* eslint-disable */
/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { IncompleteProfileAdminDashboardResponse } from '../models';
/**
 * IncompleteProfileApi - axios parameter creator
 * @export
 */
export const IncompleteProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIncompleteprofileAdmindashboardGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/incompleteprofile/admindashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IncompleteProfileApi - functional programming interface
 * @export
 */
export const IncompleteProfileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIncompleteprofileAdmindashboardGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncompleteProfileAdminDashboardResponse>> {
            const localVarAxiosArgs = await IncompleteProfileApiAxiosParamCreator(configuration).apiIncompleteprofileAdmindashboardGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * IncompleteProfileApi - factory interface
 * @export
 */
export const IncompleteProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIncompleteprofileAdmindashboardGet(options?: any): AxiosPromise<IncompleteProfileAdminDashboardResponse> {
            return IncompleteProfileApiFp(configuration).apiIncompleteprofileAdmindashboardGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IncompleteProfileApi - object-oriented interface
 * @export
 * @class IncompleteProfileApi
 * @extends {BaseAPI}
 */
export class IncompleteProfileApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IncompleteProfileApi
     */
    public apiIncompleteprofileAdmindashboardGet(options?: any) {
        return IncompleteProfileApiFp(this.configuration).apiIncompleteprofileAdmindashboardGet(options).then((request) => request(this.axios, this.basePath));
    }
}
